// Player settings (persisted to localStorage).
import { create } from "zustand";
import { persist } from "zustand/middleware";

const DEFAULTS = {
    // Graphics
    resolutionScale: 1.0,
    displayMode: "fullscreen", // fullscreen | borderless | windowed
    fullscreen: false,
    quality: "high",
    textureQuality: "high",
    shadowQuality: "high",
    lightingQuality: "high",
    effectsQuality: "high",
    shadows: true,
    antialiasing: true,
    renderDistance: 100, // %
    fov: 90,
    motionBlur: false,
    cameraShake: true,
    vsync: true,
    frameLimit: 144, // 0 = uncapped
    showFps: true,
    brightness: 1.0,
    gamma: 1.0,

    // Audio
    masterVolume: 0.7,
    musicVolume: 0.5,
    interfaceVolume: 0.9,
    weaponVolume: 0.9,
    footstepVolume: 0.8,
    voiceVolume: 0.7,
    ambientVolume: 0.6,
    sfxVolume: 0.9, // legacy — kept for compat
    muteWhenUnfocused: true,

    // Controls
    mouseSensitivity: 1.0,
    adsSensitivity: 0.85,
    sniperSensitivity: 0.7,
    invertMouse: false,
    rawMouseInput: true,
    holdToCrouch: true,
    holdToAim: true,
    weaponSwitchQuick: true,

    // Gameplay
    crosshairColor: "#00e5ff",
    crosshairSize: 24,
    hitMarker: true,
    damageIndicators: true,
    minimapRotation: true,
    showPlayerNames: true,
    viewmodelPosition: "right",
    screenEffects: true,
    subtitles: false,
    playIntroOnLaunch: true,

    // Localization
    language: "en",

    // Persisted loadouts
    lastLoadout: { mapId: "training_yard", teamSize: "1v1", difficulty: "normal" },

    // Weapon loadout (owned assignments)
    weaponLoadout: {
        primary: "rifle",
        secondary: "smg",
        pistol: "pistol",
        melee: "knife",
        grenade: "frag",
    },

    // Friends (Beta stub)
    friendCode: null,
    // Party invites (friend codes typed into the two team slots)
    partySlots: [null, null],

    // Agent selection (starter operators)
    selectedAgent: "recruit",
};

export const useSettings = create(
    persist(
        (set, get) => ({
            ...DEFAULTS,
            update: (patch) => set(patch),
            reset: () => set(DEFAULTS),
            regenerateFriendCode: () => {
                const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
                const code = Array.from({ length: 6 }, () =>
                    alphabet[Math.floor(Math.random() * alphabet.length)]
                ).join("");
                set({ friendCode: code });
                return code;
            },
            ensureFriendCode: () => {
                if (!get().friendCode) {
                    return get().regenerateFriendCode();
                }
                return get().friendCode;
            },
        }),
        { name: "axis-settings-v1" }
    )
);
